var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 3.989C5.238 4.13-6.17 38.122 15.1 54.335a28.088 28.088 0 0 0 33.8 0C70.17 38.128 58.76 4.126 32 3.99zm17.977 46.795a25.921 25.921 0 0 1-33.67 1.956 26.26 26.26 0 0 1-2.284-1.956v-3.918a7.287 7.287 0 0 1 4.988-6.924l8.996-3.002a12.677 12.677 0 0 1 7.988.001l8.994 3.001a7.287 7.287 0 0 1 4.988 6.924zM23.115 25.408c.466-11.78 17.306-11.776 17.77 0a8.885 8.885 0 0 1-17.77 0zm28.862 23.239v-1.781a9.286 9.286 0 0 0-6.355-8.822l-8.745-2.918C46.992 29.951 43.516 14.674 32 14.521c-11.517.157-14.993 15.426-4.877 20.605l-8.745 2.918a9.286 9.286 0 0 0-6.356 8.822v1.78C-2.076 31.973 10.12 5.894 32 5.99c21.88-.096 34.077 25.983 19.977 42.657z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e61004435a55b484c3a00a89f8f32cb3.svg";
export { ForwardRef as ReactComponent };